import { FieldNumberInput, FieldTimeInput } from '@/components/form/fields';
import { DatePickerInput } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/DatePickerInput';
import { HoursInput } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/HoursInput';
import { MoneyInput } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/MoneyInput';
import { TextAreaInput } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/TextAreaInput';
import { TextInput } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/TextInput';
import { SubmitButton } from '@/domain/mitarbeiter/features/anlageassistent/components/form/formComponents/SubmitButton';
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm: useAnlageassistentAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInput: TextInput,
    NumberInput: FieldNumberInput,
    TextAreaInput: TextAreaInput,
    TimeInput: FieldTimeInput,
    HoursInput: HoursInput,
    DatePickerInput: DatePickerInput,
    MoneyInput: MoneyInput,
  },
  formComponents: { SubmitButton: SubmitButton },
});
